import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { UserCohortDto } from '../../../models/user-cohort/dto/user-cohort.dto';

export const GET_COHORTS_QUERY_KEY = (organizationId: string) => [
  'cohorts',
  organizationId,
];

export function useGetCohorts(organizationId?: string) {
  const apiClient = useApiClient();

  return useQuery<UserCohortDto[]>({
    enabled: Boolean(organizationId),
    staleTime: 30_000,
    queryKey: GET_COHORTS_QUERY_KEY(organizationId!),
    queryFn: async (): Promise<UserCohortDto[]> => {
      const response = await apiClient.fetchApi<UserCohortDto[], {}>({
        method: 'GET',
        endpoint: `cohorts?organizationId=${organizationId}`,
      });
      return response;
    },
  });
}
